import { normalizePersonalizationLetter, productCharPersonalizationEnabled } from '../productPersonalization';
import { parseJewelryCustomization, productJewelryCustomizationEnabled } from '../jewelry/jewelryCustomization';
import { parsePieceCustomization, productMultiPieceEnabled } from '../pieceCustomization/pieceCustomization';

/** Lines missing required letter or jewelry customization before checkout. */
export function findCartPersonalizationIssues(lines, productsByCategory) {
  const issues = [];
  for (const line of lines || []) {
    const list = productsByCategory?.[line.categorySlug] || [];
    const p = list.find((x) => String(x.id) === String(line.productId));
    if (!p) continue;

    if (productCharPersonalizationEnabled(p)) {
      const pieceData = productMultiPieceEnabled(p) ? parsePieceCustomization(line.customization) : null;
      const pieceValid =
        pieceData &&
        Array.isArray(pieceData.pieces) &&
        pieceData.pieces.length > 0 &&
        pieceData.pieces.every((pc) => normalizePersonalizationLetter(pc?.letter));
      if (!pieceValid && !normalizePersonalizationLetter(line.customization)) {
        issues.push({
          line,
          kind: 'letter',
          message: `Choose a letter for “${line.name}” on the product page before checkout.`,
        });
      }
    }

    if (productJewelryCustomizationEnabled(p) && !parseJewelryCustomization(line.customization)) {
      issues.push({
        line,
        kind: 'jewelry',
        message: `Complete customization for “${line.name}” on the product page before checkout.`,
      });
    }
  }
  return issues;
}
